import {format as _format} from 'date-fns';


const locales: Record<string, Locale> = {
  en: enUS,
  'fr-CA': frCA,
  fr,
  'es-419': es,
  es,
  it,
  de,
  hu,
  ja,
  nl,
  pt,
  sv,
};

import {de, enUS, es, fr, frCA, hu, it, ja, nl, pt, sv} from 'date-fns/locale';


export const getBrowserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export const format = (
  date: Date,
  formatStr: string,
  extra?: {
    language: string;
  },
) =>
  _format(date, formatStr, {
    locale: locales[extra?.language || 'en'],
  });

export const timezoneName = (date: string, language: string) =>
  new Intl.DateTimeFormat(language, {
    timeZoneName: 'long',
  })
    .formatToParts(new Date(date))
    .find((part) => part.type === 'timeZoneName')?.value;
